import React, {useMemo, memo} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {checkIsDemoAccount} from "@/helpers/checkIsDemoAccount";
import {motion} from "motion/react";

import Synchronise from "@/components/Global/Banners/Synchronise/Synchronise";
import {QuickLinksDesktop, QuickLinksMobile} from "@/components/Global/Menus/QuickLinks";
import ScrollTop from "@/components/Global/ScrollTop/ScrollTop";
import SidebarMenu from "@/components/Global/SidebarMenu/SidebarMenu";
import {menuRoutes} from "@/constants/menuRoutes";

import styles from "./Layout.module.scss";
import {selectShowPinScreen} from "@/features/appSettings/appSettingsSelectors";
import {selectIsAuthenticated} from "@/features/auth/authSelectors";
import {selectUserDetails} from "@/features/user/userSelectors";
import {useWhiteLabelTheme} from "@/hooks/useWhiteLabelTheme/useWhiteLabelTheme";

export default memo(function Layout() {
  const {themeConfig} = useWhiteLabelTheme();
  // const showPinScreen = useSelector(selectShowPinScreen);
  // const showPinScreen = false;
  // const isAuthenticated = useSelector(selectIsAuthenticated);

  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const timeout = null;
  // const hasCredential = localStorage.getItem("credentials") !== null;
  // const isNativeApp = window.median !== undefined;
  const {pathname} = useLocation();

  const customerId = useSelector(selectUserDetails)?.ID || 0;
  const isDemoAccount = useMemo(() => checkIsDemoAccount(customerId), [customerId]);

  const pageVariants = {
    initial: {
      opacity: 0,
      filter: blur("5px"),
    },
    in: {
      opacity: 1,
      filter: "none",
    },
    out: {
      opacity: 0,
      filter: blur("5px"),
    },
  };

  const pageTransition = {
    type: "tween",
    ease: "linear",
    duration: 0.4,
  };

  /*
  useEffect(() => {
    if (isAuthenticated && isNativeApp) {
      if (hasCredential) {
        updateExpireTime();

        window.addEventListener("click", updateExpireTime);
        window.addEventListener("keypress", updateExpireTime);
        window.addEventListener("scroll", updateExpireTime);
        window.addEventListener("mousemove", updateExpireTime);
      }

      if (!hasCredential) {
        dispatch(togglePinScreen(true));

        updateExpireTime();

        window.addEventListener("click", updateExpireTime);
        window.addEventListener("keypress", updateExpireTime);
        window.addEventListener("scroll", updateExpireTime);
        window.addEventListener("mousemove", updateExpireTime);
      }

      document.addEventListener("visibilitychange", detectVisibilityChange);
    }

    return () => {
      if (isAuthenticated && isNativeApp) {
        if (timeout) {
          clearTimeout(timeout);
        }

        window.removeEventListener("click", updateExpireTime);
        window.removeEventListener("keypress", updateExpireTime);
        window.removeEventListener("scroll", updateExpireTime);
        window.removeEventListener("mousemove", updateExpireTime);
        document.removeEventListener("visibilitychange", detectVisibilityChange);
      }
    };
  }, [isAuthenticated, dispatch]);

  const detectVisibilityChange = e => {
    const isVisible = document.visibilityState === "visible";

    if (!isVisible) {
      dispatch(togglePinScreen(true));
      document.querySelectorAll(".modal.show").forEach(el => {
        const modalId = el.getAttribute("id");
        closeBootstrapModal(modalId);
      });
    }
  };

  const updateExpireTime = () => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      if (isAuthenticated) {
        dispatch(togglePinScreen(true));
      } else {
        dispatch(logout()).then(response => {
          localStorage.clear();
          window.median?.onesignal.userPrivacyConsent.revoke();
          navigate("/sign-in");
        });
      }
    }, 1000 * 300); // 5 minutes
  };

  const handlePinSuccess = () => {
    dispatch(togglePinScreen(false));
  }; */

  const routes = useMemo(
    () =>
      isDemoAccount
        ? menuRoutes.filter(route => route.show && route.showForDemo)
        : menuRoutes.filter(route => route.show),
    [isDemoAccount, menuRoutes],
  );

  const mobileRoutes = useMemo(
    () => menuRoutes.filter(route => route.show && route.isDesktopOnly === false),
    [menuRoutes],
  );

  return (
    <div className={styles.container} data-wider-container={themeConfig?.settings?.useWiderContainer ?? false}>
      <aside className={`${styles.sidebarMenu}`}>
        <QuickLinksDesktop routes={routes} />
      </aside>
      <motion.main
        key={pathname}
        initial="initial"
        animate="in"
        exit="out"
        className={`${styles.content}`}
        variants={pageVariants}
        transition={pageTransition}>
        {/* <Offline /> */}
        <Outlet />
        <Synchronise />
        <ScrollTop />
        <SidebarMenu />
      </motion.main>
      <footer className={`${styles.mobileMenu}`}>
        <QuickLinksMobile routes={mobileRoutes} />
      </footer>
    </div>
  );
});
